module.exports = __webpack_public_path__ + "img/button.dd5ac7b0.png";